import endpoints from '../api-endpoint-definition.json';
import { ApiCall, ParameterTypes } from '@lcms/api-definition';
import { ApiResponse } from './api-response';

const definition = new ApiCall<ApiResponse>().post('saveEntity', {
    route: endpoints.adminTaxonomyEntitySave,
    params: {
        id: {
            type: ParameterTypes.String,
            optional: true
        },
        name: {
            type: ParameterTypes.String
        },
        isDefault: {
            type: ParameterTypes.Boolean
        }
    }
})
export default definition;

